import { render } from "./index.vue?vue&type=template&id=de6e783a&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=de6e783a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-de6e783a"

export default script